//
//  SDKCustomDomainState.ts
//  Supernova SDK
//
//  Created by Fiki Sulik.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - custom domain state enum
export var CustomDomainState;
(function (CustomDomainState) {
    CustomDomainState["initial"] = "Initial";
    CustomDomainState["domainSetupInProgress"] = "DomainSetupInProgress";
    CustomDomainState["domainSetupFailed"] = "DomainSetupFailed";
    CustomDomainState["domainSetupsSucces"] = "DomainSetupSuccess";
    CustomDomainState["sslSetupInProgress"] = "SSLSetupInProgress";
    CustomDomainState["sslSetupFailed"] = "SSLSetupFailed";
    CustomDomainState["sslSetupSuccess"] = "SSLSetupSuccess";
})(CustomDomainState || (CustomDomainState = {}));
